<template>
    <div
        v-show="show"
        class="card"
    >

        <carousel
            ref="carousel"
            :autoplay="autoplay"
            :autoplay-timeout="5000"
            :speed="1000"
            :loop="true"
            :pagination-enabled="false"
            :per-page="1"
        >
            <slide
                v-for="(item, index) in items"
                :key="index"
            >
                <CatalogueTile
                    :image="item.image.sizes.large"
                    :medium-image="item.medium_image.sizes.large"
                    :small-image="item.small_image.sizes.large"
                    :title="item.title"
                    :is-new="item.isNew"
                    :link="item.url"
                    :external-link="item.url.charAt(0) !== '/'"
                    :content="item.content"
                    :lazy="false"
                />
            </slide>
        </carousel>

        <div
            class="slide-navigation-button slide-navigation-button--left"
            @click="goToPrev"
            @mouseenter="preventSlideChange"
            @mouseleave="allowSlideChange"
        >
            <ChevronLeftIcon class="slide-navigation-button__icon" />
        </div>
        <div
            class="slide-navigation-button slide-navigation-button--right"
            @click="goToNext"
            @mouseenter="preventSlideChange"
            @mouseleave="allowSlideChange"
        >
            <ChevronRightIcon class="slide-navigation-button__icon" />
        </div>

    </div>
</template>

<script>
import CatalogueTile from '~/components/CatalogueTile';
import ChevronLeftIcon from '~/static/images/chevron-left.svg';
import ChevronRightIcon from '~/static/images/chevron-right.svg';

export default {

    components: {
        CatalogueTile,
        ChevronLeftIcon,
        ChevronRightIcon,
    },

    props: {
        items: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            autoplay: false,
            show: false,
        };
    },

    mounted() {
        this.$nextTick(() => {
            this.show = true;
        });
    },

    methods: {
        goToPrev() {
            const { carousel } = this.$refs;
            const newPage = carousel.currentPage < 1 ? carousel.pageCount - 1 : carousel.currentPage - 1;
            carousel.goToPage(newPage);
        },
        goToNext() {
            this.$refs.carousel.advancePage();
        },
        preventSlideChange() {
            this.autoplay = false;
        },
        allowSlideChange() {
            this.autoplay = true;
        },
    },

};
</script>

<style lang="scss" scoped>
.slide-navigation-button {
    @apply absolute text-pink-light cursor-pointer transition-fast transition-property-color flex items-center;
    @apply top-0 bottom-0;
    &--left {
        @apply left-4;
    }
    &--right {
        @apply right-4;
    }
    &__icon {
        @apply w-8 md:w-12 h-8 md:h-12;
    }
    &:hover {
        @apply text-pink;
    }
}
</style>
